<template>
  <div class="payment-table-list">
    <p>{{ $locale("accountPayable.payment") }}</p>
    <el-table :data="tableData" class="egl-table" stripe>
      <el-table-column v-for="th in thead" :label="th.label" :prop="th.prop" align="center" :key="th.prop"></el-table-column>

      <el-table-column :label="$locale('global.control')" align="center">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="showPaymentRegistration(scope.$index, 'view')">{{ $locale("global.detail") }} </a>
            <el-divider v-if="actionType !== 'view'" direction="vertical"></el-divider>
            <a v-if="actionType !== 'view'" @click="showPaymentRegistration(scope.$index, 'edit')">{{ $locale("global.edit") }} </a>
            <el-divider v-if="actionType !== 'view'" direction="vertical"></el-divider>
            <a v-if="actionType !== 'view'" @click="delete_fn(scope.$index)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="bg-tr"></div>
  </div>
</template>

<script>
import { formatPaymentListData } from "@/assets/js/accountPayable.js";
import { deleteAccountPayablePayment } from "@/helpers/service/api/accountPayable.js";
import { mapState } from "vuex";

export default {
  name: "AccountPayablePaymentTable",
  data() {
    return {
      tableData: [],
      thead: [],
    };
  },
  computed: {
    ...mapState("api", { bankAccountList: state => state.bankAccountList }),
  },
  methods: {
    init_fn() {
      let { tableData, thead } = formatPaymentListData(this.accountPayableArr, this.bankAccountList);

      this.tableData = tableData;

      if (this.thead.length == 0) {
        this.thead = thead;
      }
    },
    delete_fn(index) {
      const that = this;
      let { id } = that.tableData[index];
      let { name } = that.tableData[index];
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        // confirm
        deleteAccountPayablePayment({ id: id }).then(res => {
          if (res.success) {
            let tableData = JSON.parse(JSON.stringify(that.tableData));

            tableData.splice(index, 1);

            that.tableData = tableData;
          }
        });
      });
    },
    showPaymentRegistration(index, act = "view") {
      this.$emit("callFatherPayment", index, act);
    },
  },
  mounted() {
    this.init_fn();
  },
  props: {
    accountPayableArr: {
      type: Array,
      default: () => [],
    },
    actionType: {
      type: String,
      default: "",
    }
  },
  watch: {
    accountPayableArr() {
      this.init_fn();
    },
  },
};
</script>
